import React, { useEffect, useState } from 'react'
import { ethers } from 'ethers'

import ConsoleDialog from './ConsoleDialog'
import { getLocalizedWalletError } from './errorMessages'

export default function NftDetailDialog({ details, contractAddress, onClose, onCopy, onTransfer, onTransferSuccess, t }) {
    const [showTransfer, setShowTransfer] = useState(false)
    const [recipient, setRecipient] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [transferring, setTransferring] = useState(false)

    const tokenId = details?.token?.id
    useEffect(() => {
        setShowTransfer(false)
        setRecipient('')
        setErrorMessage('')
        setTransferring(false)
    }, [tokenId])

    if (!details) return null
    const { token, metadata, mediaType } = details
    const media = metadata?.image || ''

    const submitTransfer = async () => {
        const normalizedRecipient = recipient.trim()
        if (!ethers.utils.isAddress(normalizedRecipient)) {
            setErrorMessage(t('请输入有效的接收地址'))
            return
        }
        if (normalizedRecipient.toLowerCase() === ethers.constants.AddressZero.toLowerCase()) {
            setErrorMessage(t('接收地址不能是零地址'))
            return
        }

        setErrorMessage('')
        setTransferring(true)
        try {
            await onTransfer(String(token.id), normalizedRecipient)
            onClose()
            onTransferSuccess?.()
        } catch (error) {
            setErrorMessage(getLocalizedWalletError(error, t))
        } finally {
            setTransferring(false)
        }
    }

    const closeDialog = () => {
        if (!transferring) onClose()
    }

    return <ConsoleDialog
        show
        onClose={closeDialog}
        title={showTransfer ? t('转账 NFT') : t('NFT详情')}
        description={showTransfer ? t('转账后 NFT 将从当前钱包移至接收地址') : (metadata?.name || `NFT #${token.id}`)}
        icon={showTransfer ? 'fa-paper-plane' : 'fa-image'}
        closeLabel={t('关闭')}
        className="nft-detail-dialog"
        footer={showTransfer ? <>
            <button type="button" className="console-button is-secondary" disabled={transferring} onClick={() => setShowTransfer(false)}>{t('取消')}</button>
            <button type="button" className="console-button is-primary" disabled={transferring} onClick={submitTransfer}>
                {transferring && <i className="fa fa-spinner loading-css" />} {t('确认转账')}
            </button>
        </> : <>
            <button type="button" className="console-button is-secondary" onClick={closeDialog}>{t('关闭')}</button>
            {onTransfer && <button type="button" className="console-button is-primary" onClick={() => setShowTransfer(true)}><i className="fa fa-paper-plane" /> {t('转账 NFT')}</button>}
        </>}
    >
        {showTransfer ? <div className="nft-transfer-form">
            <div className="nft-transfer-form__token">
                <span><i className="fa fa-cube" /></span>
                <div><small>Token ID</small><strong>#{token.id}</strong></div>
            </div>
            <label className="console-field">
                <span>{t('接收地址')}</span>
                <input value={recipient} onChange={(event) => setRecipient(event.target.value)} placeholder="0x..." autoComplete="off" spellCheck="false" />
                <small>{t('请输入接收 NFT 的钱包地址')}</small>
            </label>
            {errorMessage && <div className="console-inline-error" role="alert"><i className="fa fa-exclamation-circle" /> {errorMessage}</div>}
        </div> : <div className="nft-detail-dialog__layout">
            <div className="nft-detail-dialog__media">
                {!media ? <div className="nft-detail-dialog__placeholder"><i className="fa fa-file" /><span>{t('暂不支持此媒体类型')}</span></div> : mediaType === 'video' ? <video src={media} controls /> : mediaType === 'audio' ? <audio src={media} controls /> : <img src={media} alt={metadata?.name || `NFT #${token.id}`} />}
            </div>
            <div className="nft-detail-dialog__info">
                {metadata?.description && <p>{metadata.description}</p>}
                <div className="nft-detail-field">
                    <span>Token ID</span>
                    <code>{token.id}</code>
                    <button type="button" onClick={() => onCopy(String(token.id))} aria-label={t('复制Token ID')} title={t('复制Token ID')}><i className="fa fa-copy" /></button>
                </div>
                <div className="nft-detail-field">
                    <span>{t('合约地址')}</span>
                    <code>{contractAddress}</code>
                    <button type="button" onClick={() => onCopy(contractAddress)} aria-label={t('复制合约地址')} title={t('复制合约地址')}><i className="fa fa-copy" /></button>
                </div>
            </div>
        </div>}
    </ConsoleDialog>
}
